import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { CommonService } from './shared/services/common.service';
import { MessageService } from 'primeng/api';
import { PermissionService } from './shared/services/permission-service.service';
import { SearchHistoryService } from "./shared/services/search-history.service";
import { loadNotifications } from './store/notifications/notification.actions';
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { Notification } from './store/notifications/notification.model';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NotificationService } from './shared/services/notification.service';
import { AgentWidgetService } from './shared/services/agent-widget.service';
import { AuthService } from './auth/services/auth.service';
import { filter } from 'rxjs/internal/operators/filter';
import { take } from 'rxjs/internal/operators/take';
import { first } from 'rxjs/internal/operators/first';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment.prod';
import { DOCUMENT } from '@angular/common';
// import { PipelineStartWatcherService } from './sentry-automation/services/pipeline-start-watcher.service';
// global.d.ts
// global.d.ts
export {};

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [MessageService],
})
export class AppComponent {
  refreshLogin:any
  companyTitle = environment?.content?.companyTabTitle?.unityTitle;
  companyFavicon = environment?.content?.companyTabLogo?.unityLogo;
  constructor(
    public commonService: CommonService,
    private permissionService: PermissionService,
    private store: Store<AppState>,
    private searchHistoryService: SearchHistoryService,
    private router: Router,
    private notificationService:NotificationService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private agentWidgetService: AgentWidgetService,
    private authService: AuthService,
    // pipelineStartWatcher: PipelineStartWatcherService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.router.events.subscribe(() => {
      this.applyCompanyClass();
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        sessionStorage.setItem('lastNavigation', 'app'); // Mark as valid navigation
      }
    });
    
    // Listen for NavigationEnd events to check authentication and initialize widget
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkAndInitializeWidget();
    });
    const location = window.location.href;
    const urlArray = location.split(":");
    if (localStorage.getItem('isCustomerLogin')) {
      if (!localStorage.getItem('refreshCounter')) {
 
        localStorage.setItem('refreshCounter', '1');
      } else {

        const currentCounter = parseInt(localStorage.getItem('refreshCounter') || '0', 10);
        const newCounter = currentCounter + 1;
        localStorage.setItem('refreshCounter', newCounter.toString());
      }
    } else {

      localStorage.removeItem('refreshCounter');
    }
  }

  async ngOnInit() {
    // Intercept Stripe success redirect for hash-router compatibility.
    // Stripe returns to `http://host/success?session_id=...` (no hash) but
    // Angular uses HashLocationStrategy so the router only handles paths
    // under `#/`. Forward to the top-level `#/success` route which
    // StripeSuccessComponent is already registered on.
    const pathname = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    const sessionId = searchParams.get('session_id');
    if (pathname === '/success' && sessionId) {
      window.location.replace(
        `${window.location.origin}/#/success?session_id=${encodeURIComponent(sessionId)}`
      );
      return;
    }

    // Auth initialization (integrity check + token refresh) now runs in
    // APP_INITIALIZER (app.module.ts) before any route activates.
    // This component's ngOnInit only runs business logic that is safe
    // to execute after the token is already in memory.

    this.updateCompanyDetails();
    window.addEventListener("storage", () => this.updateCompanyDetails());
    indexedDB.deleteDatabase('wireless-app-db');
    console.log('Deleted wireless-app-db from IndexedDB');

    window.dataLayer = window.dataLayer || [];
    this.setupGtmTracking();
    await this.permissionService.updatePermission();
    this.searchHistoryService.initializeSearchHistory();
    const storedState = localStorage.getItem("state");
    if (storedState) {
      const parsedState = JSON.parse(storedState);
      const notifications: Notification[] =
        parsedState.notifications?.notifications || [];
      console.log("on load", notifications);
      this.store.dispatch(loadNotifications({ notifications }));
    }
    const currentCompany = localStorage.getItem("currentCompany") || "unity";
    this.changeClass(currentCompany);
    let notifications=[]
    await this.notificationService.fetchNotification().then((res: any) => {
      if(res.Status){
        notifications = res?.data?.data
      }
    })
    if(notifications){
      this.store.dispatch(loadNotifications({ notifications }));
    }
    // const storedState = localStorage.getItem('state');
    // if (storedState) {
    //   const parsedState = JSON.parse(storedState);
    //   const notifications: Notification[] = parsedState.notifications?.notifications || [];
    //   console.log('on load',notifications);
    //   this.store.dispatch(loadNotifications({ notifications }));
    // }
   
  
    // Optional: Store the value in a component property for binding
    this.refreshLogin = localStorage.getItem('refreshCounter');

    this.requestNotificationPermission();
    this.routeNotFound();
    
    // Initialize the agent widget globally after other initializations
    this.checkAndInitializeWidget();
  }
  
  /**
   * Check if user is authenticated and initialize the agent widget
   */
  private async checkAndInitializeWidget(): Promise<void> {
    // Check if user is logged in using the same logic as the dashboard
    const isLoggedIn = localStorage.getItem('isCustomerLogin') || this.authService.isUserLoggedIn();
    
    if (isLoggedIn) {
      try {
        // First, try to get the chat icon container from the header
        // We need to wait a short time for the header to be fully rendered
        setTimeout(async () => {
          const chatIconContainer = document.getElementById('chat-icon-container');
          
          if (chatIconContainer) {
            // Set the custom container for the agent widget
            this.agentWidgetService.setContainer(chatIconContainer);
            console.log('Chat icon container found and set');
          } else {
            console.warn('Chat icon container not found, will use default positioning');
          }
          
          // Initialize the agent widget globally (now async)
          await this.agentWidgetService.initialize();
          this.agentWidgetService.showWidget();
          console.log('Agent widget initialized globally');
        }, 500); // Wait for 500ms to ensure the header is rendered
      } catch (error) {
        console.error('Error initializing agent widget:', error);
      }
    }
  }
  
  requestNotificationPermission(): void {
    console.log("notification method call ")
    if ('Notification' in window && Notification.permission === 'default') {
      console.log(Notification.permission);
      Notification.requestPermission().then((permission) => {
        console.log(`Notification permission: ${permission}`);
      });
    }
  }

   /**
   * Method to set up Google Tag Manager (GTM) tracking
   */
   private setupGtmTracking(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('Current dataLayer:', window.dataLayer); // Add this line
        (window as any).dataLayer.push({
          event: 'pageview',
          pagePath: event.urlAfterRedirects,
        });
        
      }
    });
  }
  changeClass(company) {
    console.log(company);
    const companyNameClass = company?.replace(/\s+/g, "-").toLowerCase();
    const bodyElement = document.body;
    bodyElement.classList.forEach((cls) => {
      if (cls.startsWith("company-")) {
        bodyElement.classList.remove(cls);
      }
    });
    if (companyNameClass) {
      bodyElement.classList.add(`company-${companyNameClass}`);
    }
  }
  routeNotFound() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.activatedRoute.queryParams.pipe(first()).subscribe(params => {  // `first()` ensures only one execution
        if (params['notFound']) {
          this.commonService.showToast('error', 'Page Not Found', '😔 Sorry!!! Redirected to Home');
        }
      });
    });
  }
  
  applyCompanyClass() {
    const currentCompany = localStorage.getItem("currentCompany");
    if (currentCompany === "mingle") {
      const body = document.body;
      if (!body.classList.contains('company-mingle')) {
        body.classList.add('company-mingle');
      }
    }
  }
  openModal(content: any) {
    const modalRef = this.modalService.open(content);
    modalRef.result.finally(() => {
      this.closeModal(); // Call when modal is closed
    });
  }

  closeModal() {
    document.body.classList.remove('modal-open');

    const currentCompany = localStorage.getItem("currentCompany");
    if (currentCompany === "mingle" && !document.body.classList.contains('company-mingle')) {
      document.body.classList.add('company-mingle');
    }
  }

  updateCompanyDetails() {
    const currentCompany = localStorage.getItem("currentCompany") || "unity"; // Default to Unity Wireless

    if (currentCompany === "mingle") {
      this.companyTitle = environment?.content?.companyTabTitle?.mingleTitle;
      this.companyFavicon = environment?.content?.companyTabLogo?.mingleLogo;
    } else {
      this.companyTitle = environment?.content?.companyTabTitle?.unityTitle;
      this.companyFavicon = environment?.content?.companyTabLogo?.unityLogo;
    }

    // ✅ Update document title
    this.document.title = this.companyTitle;

    // ✅ Update favicon dynamically
    const faviconElement = this.document.getElementById("favicon") as HTMLLinkElement;
    if (faviconElement) {
      faviconElement.href = this.companyFavicon;
    }

    // ✅ Force Angular to detect changes
    this.cdr.detectChanges();
    console.log("Updated Company:", this.companyTitle, this.companyFavicon);
  }
}
